export default __webpack_public_path__ + "static/media/tweet.798f4e3e.png";